import {
  createReducer,
} from "@reduxjs/toolkit";


/* =========================================
   Initial State
========================================= */

const initialState = {
  /* General loading */
  isLoading: false,

  /* Single meal */
  isLoadingMeal: false,
  mealData: null,

  /* Create */
  isLoadingCreate: false,
  Createdmeal: null,
  errCreate: null,

  /* Update */
  isLoadingUpdate: false,
  Updatedmeal: null,

  /* Delete */
  isLoadingDelete: false,
  DeleteMessage: null,

  /* Errors */
  err: null,

  /* All meals */
  Allmeals: [],
  pagination: null,
  totalMeals: 0,

  /*
   * أبقيت totalmeals أيضًا
   * للتوافق مع الكود القديم إن كان
   * ما زال يستخدمه.
   */
  totalmeals: 0,

  /* Admin filter */
  Filltermeals: [],

  /* Enhanced filter */
  FilltermealsWithSort: [],
  FilterpaginationWithSort: null,
};


const MealsReducer =
  createReducer(
    initialState,
    (builder) => {

      builder

        /* =====================================
           GET ALL MEALS
        ====================================== */

        .addCase(
          "get_all_meals_request",
          (state) => {
            state.isLoading =
              true;

            state.err =
              null;
          }
        )


        .addCase(
          "get_all_meals_success",
          (
            state,
            action
          ) => {
            state.isLoading =
              false;


            state.Allmeals =
              action.payload
                ?.meals ||
              [];


            state.pagination =
              action.payload
                ?.pagination ||
              null;


            const total =
              action.payload
                ?.totalmeals ??
              action.payload
                ?.totalMeals ??
              0;


            state.totalMeals =
              total;

            state.totalmeals =
              total;


            state.err =
              null;
          }
        )


        .addCase(
          "get_all_meals_error",
          (
            state,
            action
          ) => {
            state.isLoading =
              false;

            state.err =
              action.payload;

            state.Allmeals =
              [];
          }
        )


        /* =====================================
           FILTER MEALS
        ====================================== */

        .addCase(
          "get_Fillter_meals_request",
          (state) => {
            state.isLoading =
              true;

            state.err =
              null;
          }
        )


        .addCase(
          "get_Fillter_meals_success",
          (
            state,
            action
          ) => {
            state.isLoading =
              false;


            state.Filltermeals =
              action.payload
                ?.meals ||
              [];


            state.pagination =
              action.payload
                ?.pagination ||
              null;


            const total =
              action.payload
                ?.totalmeals ??
              action.payload
                ?.totalMeals ??
              action.payload
                ?.pagination
                ?.totalItems ??
              0;


            state.totalMeals =
              total;

            state.totalmeals =
              total;


            state.err =
              null;
          }
        )


        .addCase(
          "get_Fillter_meals_error",
          (
            state,
            action
          ) => {
            state.isLoading =
              false;

            state.err =
              action.payload;

            state.Filltermeals =
              [];
          }
        )


        /* =====================================
           FILTER WITH SORT
        ====================================== */

        .addCase(
          "get_FillterWithSort_meals_request",
          (state) => {
            state.isLoading =
              true;

            state.err =
              null;
          }
        )


        .addCase(
          "get_FillterWithSort_meals_success",
          (
            state,
            action
          ) => {
            state.isLoading =
              false;


            state.FilltermealsWithSort =
              action.payload
                ?.meals ||
              [];


            state.FilterpaginationWithSort =
              action.payload
                ?.pagination ||
              null;


            const total =
              action.payload
                ?.totalmeals ??
              action.payload
                ?.totalMeals ??
              action.payload
                ?.pagination
                ?.totalItems ??
              0;


            state.totalMeals =
              total;

            state.totalmeals =
              total;


            state.err =
              null;
          }
        )


        .addCase(
          "get_FillterWithSort_meals_error",
          (
            state,
            action
          ) => {
            state.isLoading =
              false;

            state.err =
              action.payload;

            state.FilltermealsWithSort =
              [];
          }
        )


        /* =====================================
           GET SINGLE MEAL
        ====================================== */

        .addCase(
          "get_meal_request",
          (state) => {
            state.isLoadingMeal =
              true;

            state.err =
              null;
          }
        )


        .addCase(
          "get_meal_success",
          (
            state,
            action
          ) => {
            state.isLoadingMeal =
              false;

            state.mealData =
              action.payload ||
              null;

            state.err =
              null;
          }
        )


        .addCase(
          "get_meal_error",
          (
            state,
            action
          ) => {
            state.isLoadingMeal =
              false;

            state.mealData =
              null;

            state.err =
              action.payload;
          }
        )


        /* =====================================
           CREATE MEAL
        ====================================== */

        .addCase(
          "create_meal_request",
          (state) => {
            state.isLoadingCreate =
              true;

            state.errCreate =
              null;
          }
        )


        .addCase(
          "create_meal_success",
          (
            state,
            action
          ) => {
            state.isLoadingCreate =
              false;


            state.Createdmeal =
              action.payload;


            /*
             * نضيف الوجبة للقائمة
             * إذا كانت القائمة محملة.
             */

            if (
              action.payload
            ) {
              state.Allmeals.unshift(
                action.payload
              );
            }


            state.errCreate =
              null;
          }
        )


        .addCase(
          "create_meal_error",
          (
            state,
            action
          ) => {
            state.isLoadingCreate =
              false;

            state.errCreate =
              action.payload;
          }
        )


        /* =====================================
           UPDATE MEAL
        ====================================== */

        .addCase(
          "update_meal_request",
          (state) => {
            state.isLoadingUpdate =
              true;

            state.err =
              null;
          }
        )


        .addCase(
          "update_meal_success",
          (
            state,
            action
          ) => {
            state.isLoadingUpdate =
              false;


            state.Updatedmeal =
              action.payload;


            state.mealData =
              action.payload;


            const updatedMeal =
              action.payload;


            if (
              !updatedMeal?._id
            ) {
              return;
            }


            /*
             * تحديث الوجبة داخل
             * جميع القوائم الموجودة.
             */

            const updateList =
              (list) => {

                if (
                  !Array.isArray(
                    list
                  )
                ) {
                  return list;
                }


                return list.map(
                  (meal) =>
                    meal._id ===
                    updatedMeal._id
                      ? updatedMeal
                      : meal
                );
              };


            state.Allmeals =
              updateList(
                state.Allmeals
              );


            state.Filltermeals =
              updateList(
                state.Filltermeals
              );


            state.FilltermealsWithSort =
              updateList(
                state.FilltermealsWithSort
              );


            state.err =
              null;
          }
        )


        .addCase(
          "update_meal_error",
          (
            state,
            action
          ) => {
            state.isLoadingUpdate =
              false;

            state.err =
              action.payload;
          }
        )


        /* =====================================
           DELETE MEAL
        ====================================== */

        .addCase(
          "delete_meal_request",
          (state) => {
            state.isLoadingDelete =
              true;

            state.err =
              null;
          }
        )


        .addCase(
          "delete_meal_success",
          (
            state,
            action
          ) => {
            state.isLoadingDelete =
              false;


            /*
             * الـAction الجديد يرجع:
             *
             * {
             *   id,
             *   message
             * }
             */

            const deletedId =
              action.payload
                ?.id;


            state.DeleteMessage =
              action.payload
                ?.message ||
              action.payload;


            if (
              deletedId
            ) {

              state.Allmeals =
                state.Allmeals.filter(
                  (meal) =>
                    meal._id !==
                    deletedId
                );


              state.Filltermeals =
                state.Filltermeals.filter(
                  (meal) =>
                    meal._id !==
                    deletedId
                );


              state.FilltermealsWithSort =
                state.FilltermealsWithSort.filter(
                  (meal) =>
                    meal._id !==
                    deletedId
                );


              if (
                state.mealData
                  ?._id ===
                deletedId
              ) {
                state.mealData =
                  null;
              }


              if (
                state.totalMeals >
                0
              ) {
                state.totalMeals -=
                  1;
              }


              if (
                state.totalmeals >
                0
              ) {
                state.totalmeals -=
                  1;
              }
            }


            state.err =
              null;
          }
        )


        .addCase(
          "delete_meal_error",
          (
            state,
            action
          ) => {
            state.isLoadingDelete =
              false;

            state.err =
              action.payload;
          }
        )


        /* =====================================
           CLEAR SINGLE MEAL
        ====================================== */

        .addCase(
          "clear_meal",
          (state) => {

            state.mealData =
              null;

            state.Updatedmeal =
              null;

            state.Createdmeal =
              null;

            state.err =
              null;

            state.isLoadingMeal =
              false;
          }
        )


        /* =====================================
           CLEAR ERRORS
        ====================================== */

        .addCase(
          "clear_error",
          (state) => {

            state.err =
              null;

            state.errCreate =
              null;

            state.DeleteMessage =
              null;

            state.Updatedmeal =
              null;

            state.Createdmeal =
              null;

            state.isLoadingDelete =
              false;

            state.isLoadingUpdate =
              false;

            state.isLoadingCreate =
              false;
          }
        );

    }
  );


export default MealsReducer;